module Meevo.Plugins.Register {

    export class RegisterCareCreditService {
        private careCreditPaymentsSection: CareCreditPaymentsSection;
        private careCreditMerchantAccount: Meevo.Model.MerchantAccount;

        constructor(
            protected modalService: Meevo.Components.Modal.IModalService
        ) {
        }

        getCareCreditMerchantAccount(registerContext: any) {
            registerContext.getMerchantAccountByProvider(Meevo.Model.MerchantAccountProviderEnum.CareCredit).then((merchantAccount: Meevo.Model.MerchantAccount) => {
                this.careCreditMerchantAccount = merchantAccount;
            })
        }

        handleCareCreditNoSaleMessage(registerContext: any): boolean {
            // should only be 1 CareCredit payment but keeping this generic
            let careCreditPayments = _(registerContext.sale.paymentLines).filter(paymentLine => paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CareCredit);

            if (careCreditPayments.length === 0) {
                return false;
            }

            let hasCareCreditPayment = _(careCreditPayments).any(paymentLine => paymentLine.amount > 0);

            if (hasCareCreditPayment) {
                this.modalService.alert('MESSAGE_REGISTER_CONFIRM_NOSALE_WITH_CARECREDIT_PAYMENT');
                return true;
            }

            let hasCareCreditRefund = _(careCreditPayments).any(paymentLine => paymentLine.amount < 0);

            if (hasCareCreditRefund) {
                this.modalService.alert('MESSAGE_REGISTER_CONFIRM_NOSALE_WITH_CARECREDIT_REFUND');
                return true;
            }

            return false;
        }

        isCareCreditPayment(paymentLine: Model.SalePayment): boolean {
            return paymentLine &&
                !paymentLine.isPending &&
                paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CareCredit;
        }

        hasCareCreditPaymentLines(sale: any): boolean {
            if (!sale) {
                return false;
            }

            return _(sale.paymentLines).any(paymentLine => this.isCareCreditPayment(paymentLine));
        }

        hasCareCreditPayment(sale: any): boolean {
            if (!sale) {
                return false;
            }

            return _(sale.paymentLines).any(paymentLine => this.isCareCreditPayment(paymentLine));
        }

        isFinalizedCareCreditPayment(registerContext: any, paymentLine: Model.SalePayment): boolean {
            return this.isCareCreditPayment(paymentLine) && registerContext.isHostedPaymentFinalized(paymentLine);
        }

        getFinalizedCareCreditPaymentLines(registerContext: any, sale: any): Model.SalePayment[] {
            if (!sale) {
                return null;
            }

            return _(sale.paymentLines).filter(paymentLine => this.isFinalizedCareCreditPayment(registerContext, paymentLine));
        }

        updateCareCreditPaymentType(paymentCats: any, sale: any) {
            if (!this.careCreditPaymentsSection) {
                return;
            }

            // only allow 1 CareCredit payment line
            const registerPaymentCat = _(paymentCats).find((paymentCat: RegisterPaymentCat) => paymentCat.sectionType === RegisterSectionTypeEnum.CareCreditPayment);
            if (registerPaymentCat) {
                registerPaymentCat.isDisabled = this.hasCareCreditPaymentLines(sale);
            }
        }

        buildCareCreditOption(registerContext: any, registerPaymentCat) {
            if (!this.careCreditMerchantAccount) {
                return;
            }
            // CareCredit does not currently support mobile
            if (device.mobile()) {
                return;
            }

            this.careCreditPaymentsSection = new CareCreditPaymentsSection(registerContext, this.careCreditMerchantAccount);
            registerContext.sections.push(this.careCreditPaymentsSection);
            registerPaymentCat.sectionType = RegisterSectionTypeEnum.CareCreditPayment;
            registerPaymentCat.sequence = 65;
            registerPaymentCat.iconName = 'pmtopt_carecredit.svg';
            registerPaymentCat.isDisabled = this.hasCareCreditPaymentLines(registerContext.sale);
            registerPaymentCat.disabledMessage = 'MESSAGE_CARECREDIT_ALREADY_EXISTS';
        }

        static factory(): Function {
            let svc = (
                modalService,
            ) => new RegisterCareCreditService(
                modalService,
            );

            svc.$inject = [
                "meevo.components.modal.ModalService",
            ];

            return svc;
        }
    }

    angular.module("meevo.plugins.register")
        .service("meevo.plugins.register.RegisterCareCreditService", RegisterCareCreditService.factory());
}